import { DOCUMENT } from '@angular/common';
import { inject, Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BrokerStylingService } from './broker-styling.service';

@Injectable({
  providedIn: 'root'
})
export class GtmService {

  private brokerService = inject(BrokerStylingService)
  private renderer: Renderer2;
  private gtmId: string | null = null;

  private gtmIdsByDomain: { [key: string]: string } = {
    'chill.ie': 'GTM-7DRT',
    'hfq.quotedevil.ie': 'GTM-KHQBGWL',
    'uat-hfq.quotedevil.ie': 'GTM-MR4XJ79F',
    'localhost': 'GTM-KHQBGWL'
  };

  constructor(
    @Inject(DOCUMENT) private document: Document,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public loadGtm(): Promise<void> {
    return new Promise((resolve) => {
      var broker = this.brokerService.getBrokerDetailFromDomain()
      this.gtmId =  broker.gtm
      console.warn(`GTM: ${this.gtmId}`)

      if (!this.gtmId) {
        console.warn(`GTM não configurado para o domínio: ${broker.domain}`);
        return resolve();
      }

      this.insertGtmScript(this.gtmId);
      resolve();
    });
  }

  private insertGtmScript(gtmId: string): void {
    // HEAD
    const script = this.renderer.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    this.renderer.appendChild(this.document.head, script);

    // BODY (opcional)
    const noscript = this.renderer.createElement('noscript');
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    this.renderer.appendChild(this.document.body, noscript);
  }
}
